import React from "react";
import {useHistory} from "react-router-dom";
import {Row} from "antd";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";
import {DailyPoolSlotTable} from "../components/dailyPoolSlotTable/DailyPoolSlotTable";

const DailyPoolSlots = ({poolId}) => {
    const history = useHistory();
    const stores = useStore();
    const [recall, setRecall] = React.useState(false);
    const [dailySlots, setDailySlots] = React.useState([]);
    const [dailySlotsLoading, setDailySlotsLoading] = React.useState(false);

    const [dailyShiftTableLoading, dailyShiftTable, ,] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.poolShiftStore.getDailyShiftTable.bind(null, {}),
        dependencies: [recall],
        initialCall: Boolean(poolId),
        condition: Boolean(poolId),
        callbackFunc: async result => {
            if (result && result?.data?.length > 0) {
                const firstSlotDate = result?.data?.[0]?.date || null;
                const lastSlotDate = result?.data?.[result?.data?.length - 1]?.date || null;

                try {
                    setDailySlotsLoading(true);
                    const dailySlotsResult = await stores.poolShiftStore.getDailySlotsByPoolId({
                        poolId: poolId,
                        startDate: firstSlotDate,
                        endDate: lastSlotDate
                    });
                    setDailySlots(dailySlotsResult?.data || []);
                } catch (e) {
                } finally {
                    setDailySlotsLoading(false);
                }
            }
        }
    });

    return (
        <div>
            <Row style={{justifyContent: "space-between", marginBottom: "16px"}}>
                <b onClick={() => history.goBack()} style={{cursor: "pointer"}}>
                    {"<"} Geri Dön
                </b>
            </Row>

            <DailyPoolSlotTable
                poolId={poolId}
                tableData={dailyShiftTable.data || []}
                slotsData={dailySlots || []}
                loading={dailySlotsLoading}
                recall={() => setRecall(!recall)}
                pagination={false}
            />
        </div>
    );
};

export default DailyPoolSlots;
